import Router from "@src/lib/router";
import toast from "react-hot-toast";
import { CONTENT_TYPE, CONTENT_DEEPLINK_ACTIONS } from "../store/constants";
import { handleStartDownloadContent } from "./handleDownloadContent";
import hitStoragePermissionRequiredAction from "./handleStoragePermissions";
import {
  hitContentDeeplinkNew,
  hitContentDeeplinkOld,
} from "./hitContentDeeplink";
import { getTestbookSubscribeService } from "../store/services";
import parseError from "@src/utils/parseError";

const handleOpenContent = (contentObj) => {
  //// alertcontentObj.contentType);
  switch (contentObj?.contentType) {
    case CONTENT_TYPE.LIVE_CLASS:
      if (contentObj?.videoType === "youtube-hosted") {
        handleYoutubeVideo(contentObj);
      } else {
        let courseId = Router?.query?.courseId;
        courseId = courseId ? Number(courseId) : courseId;
        hitContentDeeplinkNew(CONTENT_DEEPLINK_ACTIONS.ACTION_PLAY_VIDEO, {
          ...(courseId ? { courseId } : {}),
          ...contentObj,
          videoTab: "LIVE_CLASS"
        });
      }
      break;
    case CONTENT_TYPE.VIDEO: {
      if (contentObj?.videoType === "youtube-hosted") {
        handleYoutubeVideo(contentObj);
      } else {
        let courseId = Router?.query?.courseId;
        courseId = courseId ? Number(courseId) : courseId;
        hitContentDeeplinkNew(CONTENT_DEEPLINK_ACTIONS.ACTION_PLAY_VIDEO, {
          ...(courseId ? { courseId } : {}),
          ...contentObj,
          videoTab: "COURSE_VIDEO"
        });
      }
      break;
    }
    case CONTENT_TYPE.DOCUMENT: {
      switch (contentObj?.format) {
        case "jpg":
        case "png":
        case "jpeg":
        case "epub":
        case "pdf":
          let payload = {
            paramOne: contentObj.url,
            paramTwo: contentObj.name,
            paramThree: contentObj.description,
          }
          if (contentObj?.isPublicationEnabled && contentObj?.format === "pdf") {
            payload["paramFour"] = contentObj?.id?.toString()
          }
          else if (contentObj?.format === "epub") {
            payload["paramFour"] = contentObj?.id?.toString()
          }
          hitContentDeeplinkOld(CONTENT_DEEPLINK_ACTIONS.SCREEN_CONTENT, payload);
          break;
        case "zip":
          handleStartDownloadContent(contentObj);
          break;
        default:
          handleOpenOtherDocuments(contentObj);
      }
      break;
    }
    case CONTENT_TYPE.TEST: {
      hitStoragePermissionRequiredAction(attemptTestDeeplinkAction, contentObj);
    }
    default:
      return false;
  }
};

// FUNCTION TO OPEN OTHER DOCUMENTS LIKE .ppt .xls .doc (except images, pdf, zip)
const handleOpenOtherDocuments = (contentObj) => {
  // iOS OPENS DOCUMENT USING SCREEN_CONTENT ONLY
  hitContentDeeplinkOld(
    CONTENT_DEEPLINK_ACTIONS.SCREEN_CONTENT,
    {
      paramOne: contentObj.url,
      paramTwo: contentObj.name,
      paramThree: contentObj.description,
    },
    true,
    false
  );

  const googleDocURL = `http://docs.google.com/gview?embedded=true&url=`;
  // ANDROID ACTION FOR OPENING OTHER DOCUMENTS
  hitContentDeeplinkOld(
    CONTENT_DEEPLINK_ACTIONS.UTIL_WEBVIEW,
    {
      paramOne: `${googleDocURL}${contentObj.url}`,
      paramThree: "1", // HIDING THE TOOLBAR IN WEBVIEW
    },
    false,
    true
  );
};

// FUNCTION TO HIT TEST DEEPLINK
const attemptTestDeeplinkAction = async (contentObj) => {
  if (contentObj?.typeOfTest == 2 && contentObj?.solutionUrl) {
    hitContentDeeplinkNew(
      CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_ATTEMPT,
      contentObj,
      true,
      true,
      contentObj.solutionUrl
    );
  }
  else if (contentObj?.typeOfTest == 2) {
    try {
      let data = await getTestbookSubscribeService({ courseId: contentObj.courseId, testId: contentObj.testId, contentId: contentObj.id });
      if (data?.status == 200) {
        if (contentObj?.scoredMarks || contentObj?.scoredMarks === 0) {
          hitContentDeeplinkNew(
            CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_REATTEMPT,
            contentObj,
            true,
            true,
            contentObj.URL
          );
        } else {
          hitContentDeeplinkNew(
            CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_ATTEMPT,
            contentObj,
            true,
            true,
            contentObj.URL
          );
        }
      }
    }
    catch (err) {
      parseError(err);
    }

  }
  else {
    if (contentObj?.scoredMarks || contentObj?.scoredMarks === 0) {
      hitContentDeeplinkNew(
        CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_REATTEMPT,
        contentObj,
        true,
        true,
        contentObj.URL
      );
    } else {
      hitContentDeeplinkNew(
        CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_ATTEMPT,
        contentObj,
        true,
        true,
        contentObj.URL
      );
    }
  }
};

// FUNCTION TO HIT YOUTUBE VIDEO DEEPLINK
const handleYoutubeVideo = (contentObj) => {
  const source = "Course";
  const sourceId = "1"; // TODO
  const playerType = "youtube-html";
  const speedControls = "0";
  const courseIdStr = `${contentObj?.courseId}`;
  const url = contentObj?.url;

  const deeplinkJSONAndroid = {
    paramOne: url,
    paramTwo: source,
    paramThree: courseIdStr,
    paramFour: playerType,
    paramFive: speedControls,
  };
  const deeplinkJSONiOS = {
    paramOne: url,
    paramTwo: sourceId,
    paramThree: courseIdStr,
    paramFour: contentObj?.name,
  };
  hitContentDeeplinkOld(
    CONTENT_DEEPLINK_ACTIONS.UTIL_VIDEO_V2,
    deeplinkJSONAndroid,
    false,
    true
  );
  hitContentDeeplinkOld(
    CONTENT_DEEPLINK_ACTIONS.UTIL_VIDEO_V2,
    deeplinkJSONiOS,
    true,
    false
  );
};

export default handleOpenContent;
